import { render, staticRenderFns } from "./dragVerify.vue?vue&type=template&id=81ad1542&scoped=true&"
import script from "./dragVerify.vue?vue&type=script&lang=js&"
export * from "./dragVerify.vue?vue&type=script&lang=js&"
import style0 from "./dragVerify.vue?vue&type=style&index=0&id=81ad1542&scoped=true&lang=less&"
import style1 from "./dragVerify.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad1542",
  null
  
)

export default component.exports